import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";
export const getNoShowData = async (payload) => {
  try {
    return await postRequest(urls.GET_NOSHOW_DATA, payload);
  } catch (err) {
    return err;
  }
};
